import "./AdminLayout.scss";
import cx from "classnames";
import { Outlet, Navigate } from "react-router-dom";
import Menu from "../Menu";
import { Loading } from "../../../../ui";
import useAdminUser from "../../../../data/useAdminUser";
import useAgencyUser from "../../../../data/useAgencyUser";

function AdminLayout({ className }) {
  const { isLoading: adminLoading, loggedOut: adminLoggedOut, role: adminRole, token: adminToken } = useAdminUser();
  const { isLoading: agencyLoading, loggedOut: agencyLoggedOut, role: agencyRole, token: agencyToken } = useAgencyUser();
  const isLoading = (adminToken && adminLoading) || (agencyToken && agencyLoading);
  const loggedOut = (adminToken && adminLoggedOut) || (agencyToken && agencyLoggedOut);
  const role = adminRole || agencyRole;
  const token = adminToken || agencyToken;

  if (isLoading) return <Loading />;
  if (!token) return <Navigate to="/admin/sign-in" />;
  if (!isLoading && loggedOut) return <Navigate to="/admin/sign-in" />;
  if (!role || !["MANAGER", "MANAGER_RETARGEO", "ADMIN", "SUPERUSER", "AGENCY"].some((el) => el === role)) return <Navigate to="/admin/sign-in" />;

  return (
    <div className={cx("AdminMainLayout", className)} style={{ display: "flex" }}>
      <div style={{ width: "200px", position: "fixed", height: "100vh", overflowY: "auto" }}>
        <Menu />
      </div>
      <div className="AdminMainLayout-content" style={{ marginLeft: "180px", width: "calc(100% - 200px)" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
